<template>

  <el-container>
    <el-main class="pc">
      <el-header class="index-header">
        <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
           <div class="w1200 pos-rel " style="height:60px">
             <div class="logobox fl">
                <img src="../assets/img/logo.png" >
              </div>
              <div class="titleNames fl over_h">
                     <div class="titleT fl">活畜在线交易平台</div>
                   <!--  <div class="fl areaTitle" >
                        <img src="../assets/img/u218.png" > {{address.authProvincesCityAreasName}}
                      </div> -->
              </div>
          <!--    <div>
                <input v-model="inputVal" type="text" placeholder="请输入设备名称" name="" id="" value="" />
                <div @click="search">搜索</div>
              </div> -->

              <div class="yzm-search">
              	<div id="searchtxt" class="searchtxt">
              		<input @input="inputBtn" v-model="inputVal" type="text" placeholder="请输入牧场名称" name="" id="" value="" />
              	</div>
              	<div class="searchbtn">
              		<div @click="search">搜索</div>
              	</div>
               <div class="yzm-add-content">
               	<a @click="publish">发布内容</a>
               </div>
              </div>
               <!-- <el-form v-show="publishForm==true"> -->


                <!-- <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)"> -->




              <el-submenu v-if="user!=null" index="2" class="submenu">
                <!-- <template slot="title">{{user.userRealName}}</template> -->
                <template slot="title" >
                <!--  <img class="titleImg" v-if="user.avatar!=null||user.avatar!=''" :src="user.avatar" >
                  <img class="titleImg" v-else src="../assets/img/u8.png" >
        -->
                  <span class="text">{{user.nickname||''}}</span>
                </template>

                <template v-if="user!=null">
                <el-menu-item  @click="editInfo()" index="2-3">账号管理</el-menu-item>
                <el-menu-item v-if="user!=null" @click="exit()" index="2-3">退出</el-menu-item>
                </template>
              </el-submenu>
              <div v-else class="loginBtn" @click="exits()">登录&nbsp;|&nbsp;注册</div>
           </div>
         </el-menu>
      </el-header>
      <el-container class="index-con">
        <el-container class="main-con">
          <el-main class="index-main">
            <div class="type w1200">
              <div v-for="(item,i) in type" @click="tab(i)" :class="i==tabIndex?'cur':''" :key="i">{{item}}</div>
            </div>
            <div style="height:70px"></div>
            <div class="swiper w1200" v-if="tabIndex==0&&!detailFlag&&!showSearch">
              <div class="download" @click="downLoad">点击下载</div>

            </div>
            <div class="typeBlock" v-if="tabIndex==0&&!detailFlag&&!showSearch">
              <div class="layuiPdaList w1200">
                <div class="typeCover" v-for="(it,i) in typeList" :key="i">
                  <div class="typeName" v-if="it.livestockType==1">羊</div>
                  <div class="typeName" v-if="it.livestockType==2">猪</div>
                  <div class="typeName" v-if="it.livestockType==3">牛</div>
                  <div class="typeName" v-if="it.livestockType==4">驴</div>
                  <!-- <div class="typeName" v-if="it.livestockType==5">鸡</div> -->
                  <ul class="oul over_h">
                    <li v-if="it.livestockType!=0&&it.livestockType!=5" v-for="(item,index) in it.dataList" @click="toDetail(item)" :key="index">
                      <div class="oli">
                        <div v-if="item.takeEffect==1" class="aiAb open"><img
                            src="../assets/img/openai.svg" /><span>值守中</span></div>
                        <div v-else-if="item.takeEffect==2" class="aiAb unnormal"><img
                            src="../assets/img/u717.png" /><span>异常</span></div>
                        <div class="aiAb unopen" v-else><img src="../assets/img/u717.png"><span>未开启</span></div>
                        <div class="imgCover">

                          <div class="img">
                            <div v-if="item.imgUrl&&item.imgUrl!=null&&item.imgUrl!=''" :style="{'backgroundImage': 'url('+item.imgUrl+')'}"></div>
                            <div v-else style="background: url(../assets/img/img1.png) no-repeat center;background-size: cover;"></div>
                          </div>
                        </div>


                        <div class="info">
                          <div class="name">
                            <div class="over_h">
                              <div class=" fl text-"
                                style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                {{item.deviceName||'暂无设备'}}</div>
                              <!-- <div class="fl liveW">{{item.livestockType}} /</div> -->
                            </div>
                          </div>
                          <div class="users">
                            <div v-if="item.avatarUrl=='undefined' ||item.avatarUrl=='null' || item.avatarUrl==null || item.avatarUrl==undefined || item.avatarUrl==''">
                              <img src="../assets/img/images/u998.png" />
                            </div>
                            <div v-else>
                              <img :src="item.avatarUrl" />
                            </div>
                            {{item.nickname||'用户名'}}
                           <!-- <span class="userID">ID:{{item.userAccount}}</span> -->
                          </div>
                          <div class="address"><img src="../assets/img/u10.png" />{{item.deviceAddress}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- </div> -->
              </div>
            </div>
            <div v-if="tabIndex!=0&&!detailFlag">
              <div class="layuiPdaList w1200">
                  <ul class="oul over_h" v-if="lists.length>0">
                    <li v-for="(item,index) in lists" @click="toDetail(item)" :key="index">
                      <div class="oli">
                        <div v-if="item.takeEffect==1" class="aiAb open"><img
                            src="../assets/img/openai.svg" /><span>值守中</span></div>
                        <div v-else-if="item.takeEffect==2" class="aiAb unnormal"><img
                            src="../assets/img/u717.png" /><span>异常</span></div>
                        <div class="aiAb unopen" v-else><img src="../assets/img/u717.png"><span>未开启</span></div>
                        <div class="imgCover">
                          <div class="img">
                            <div v-if="item.imgUrl&&item.imgUrl!=null&&item.imgUrl!=''" :style="{'backgroundImage': 'url('+item.imgUrl+')'}"></div>
                            <div v-else style="background: url(../assets/img/img1.png) no-repeat center;background-size: cover;"></div>
                          </div>
                        </div>


                        <div class="info">
                          <div class="name">
                            <div class="over_h">
                              <div class=" fl text-"
                                style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                {{item.deviceName||'暂无设备'}}</div>
                              <!-- <div class="fl liveW">{{item.livestockType}} /</div> -->
                            </div>
                          </div>
                          <div class="users">
                            <div v-if="item.avatarUrl=='undefined' ||item.avatarUrl=='null' || item.avatarUrl==null || item.avatarUrl==undefined || item.avatarUrl==''">
                              <img src="../assets/img/images/u998.png" />
                            </div>
                            <div v-else>
                              <img :src="item.avatarUrl" />
                            </div>
                            {{item.nickname||'用户名'}}
                            <!-- <span class="userID">ID:{{item.userAccount}}</span> -->
                          </div>
                          <div class="address"><img src="../assets/img/u10.png" />{{item.deviceAddress}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div v-if="lists.length<1" style="min-height:400px"><img style="display:block;margin:50px auto 0" src="../assets/img/u1497.png" /></div>
                <!-- </div> -->
              </div>
              <!-- :page-size="15"
              :total="total" -->
                <el-pagination
                  layout="prev, pager, next"
                  background
                  @current-change="currentPage"
                  @prev-click="prev"
                  @next-click="next"
                   style="margin-top:50px"
                   page-size="10"
                  :total="total">
                </el-pagination>

              <!--  <div class="bottomPage">
                  <div @click="prePage">上一页</div>
                  <div @click="nextPage">下一页</div>
                </div> -->

            </div>
            <div v-if="showSearch">
              <div class="layuiPdaList w1200">
                  <ul class="oul over_h">
                    <li v-for="(item,index) in lists" @click="toDetail(item)" :key="index">
                      <div class="oli">
                        <div v-if="item.takeEffect==1" class="aiAb open"><img
                            src="../assets/img/openai.svg" /><span>值守中</span></div>
                        <div v-else-if="item.takeEffect==2" class="aiAb unnormal"><img
                            src="../assets/img/u717.png" /><span>异常</span></div>
                        <div class="aiAb unopen" v-else><img src="../assets/img/u717.png"><span>未开启</span></div>
                        <div class="imgCover">
                          <div class="img">
                            <div v-if="item.imgUrl&&item.imgUrl!=null&&item.imgUrl!=''" :style="{'backgroundImage': 'url('+item.imgUrl+')'}"></div>
                            <div v-else style="background: url(../assets/img/img1.png) no-repeat center;background-size: cover;"></div>
                          </div>
                        </div>


                        <div class="info">
                          <div class="name">
                            <div class="over_h">
                              <div class=" fl text-"
                                style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                {{item.deviceName||'暂无设备'}}</div>
                              <!-- <div class="fl liveW">{{item.livestockType}} /</div> -->
                            </div>
                          </div>
                         <div class="users">
                           <div v-if="item.avatarUrl=='undefined' ||item.avatarUrl=='null' || item.avatarUrl==null || item.avatarUrl==undefined || item.avatarUrl==''">
                             <img src="../assets/img/images/u998.png" />
                           </div>
                           <div v-else>
                             <img :src="item.avatarUrl" />
                           </div>
                           {{item.nickname||'用户名'}}
                           <!-- <span class="userID">ID:{{item.userAccount}}</span> -->
                         </div>
                          <div class="address"><img src="../assets/img/u10.png" />{{item.deviceAddress}}</div>
                        </div>
                      </div>
                    </li>
                  </ul>

                <!-- </div> -->

              </div>
               <div v-if="lists.length<1" style="min-height:400px"><img style="display:block;margin:50px auto 0" src="../assets/img/u1497.png" /></div>
              <!-- :page-size="15"
              :total="total" -->
           <!--  <div class="bottomPage">
               <div @click="prePage">上一页</div>
               <div @click="nextPage">下一页</div>
             </div> -->
            <el-pagination
              layout="prev, pager, next"
              background
              @current-change="currentPage"
              @prev-click="prev"
              @next-click="next"
               style="margin-top:50px"
               page-size="10"
              :total="total">
            </el-pagination>
            </div>
            <div class="cover w1200" v-if="detailFlag">
              <div class="goBack" @click="goback">< 返回 </div>
              <div class="details">
                <img style="margin-top:15px" src="../assets/img/u74.png" />
              </div>
              <div class="detailsBox">
                <div class="detailsBoxL fl">
                   <div class="imgUrl" :style="{'backgroundImage': 'url('+detail.imgUrl+')'}"></div>
                   <div class="detailsBoxLL">
                     <h3>{{detail.deviceName}}</h3>

                      <div class="device">
                        <span>牧场地址</span>
                        <span>{{detail.deviceAddress}}</span>
                      </div>
                      <div class="device">
                        <span>养殖种类</span>
                        <span v-if="detail.livestockType==1">羊</span>
                        <span v-if="detail.livestockType==2">猪</span>
                        <span v-if="detail.livestockType==3">牛</span>
                        <span v-if="detail.livestockType==4">驴</span>
                      </div>
                     <div class="device">
                        <span>牧场主</span>
                        <span>{{detail.nickname}}</span>
                      </div>
                      <div class="device">
                        <span>联系电话</span>
                        <span v-if="!showPhone">{{detail.userAccounts}}</span>
                        <span v-else="showPhone">
                          <span v-if="detail.userAccount=='' || detail.userAccount== null|| detail.userAccount== 'null'">暂无联系电话</span>
                          <span v-else>{{detail.userAccount}}</span>


                        </span>
                      </div>
                      <div class="device">
                          <div v-if="!showPhone" class="item" @click="phone">点击查看完整电话</div>
                          <!-- <div v-else class="item" @click="phone('1')">点击隐藏联系电话</div> -->

                      </div>
                   </div>
                   <div style="clear: both;"></div>
                </div>
                <div class="detailsBoxR fr">
                  <h3>推荐牧场<span>广告</span></h3>
                  <ul>
                    <li v-if="index<4&&item.id!=detail.id" v-for="(item,index) in typeList[detail.livestockType].dataList" :key="index">
                     <!-- <div style="background: url(../assets/img/cy1.png) no-repeat center;background-size: cover;"></div> -->
                      <img :src="item.imgUrl" />
                      <p>{{item.deviceName}}</p>
                    </li>
                  </ul>
                </div>
                <div style="clear: both;"></div>
              </div>


            </div>
            <footer class="footer">
              <p>备案号：<a href="http://beian.miit.gov.cn/" target="_blank">陕ICP备2020017629号</a>  <a href="http://xiaomuding.com/measures.html" target="_blank">网站监管措施</a></p>
              <p>陕西微牧云信息科技有限公司</p>
              <p>电话：159 2939 7888&emsp;地址：陕西省榆林市高新区明珠大道榆商大厦B座26层</p>
              <p>本站信息皆来自第三方用户发布，请谨慎甄别信息真实性与合法性，如有侵犯您利益，请第一时间与我们联系</p>
            </footer>
          </el-main>
        </el-container>
      </el-container>
    </el-main>
    <el-main class="mobile">
      <div class="wrap">
      	<div class="main">
      		<div class="header"><a><img src="../assets/img/images/logo_u13.png" /></a></div>
      		<div class="cont">
            <el-dialog  :visible.sync="dialogTableVisible" fullscreen=true
             :show-close="showclose">
           <div>
            <img width="80%" style="margin-left: 20%;" src="../assets/img/images/caozuoguanli.png" alt="" srcset="">
            </div>
</el-dialog>
      			<div class="contTxt">
      				<div class="height120"></div>
      				<div class="tit1 home-title word word--magneto wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="1s">活畜在线交易市场&nbsp;&nbsp;牧场在线展销平台</div>
      				<div style="height:12px;"></div>
      				<div class="tit2 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="1s">搞养殖&nbsp;卖牲畜&nbsp;·&nbsp;就上小牧丁！</div>
      				<div style="height:12px;"></div>
      				<div style="height:12px;"></div>
      				<div class="tit1 wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="1s">一键免费绑定监控</div>
      				<div style="height:12px;"></div>
      				<div class="tit1 wow fadeInUp" data-wow-delay="0.55s" data-wow-duration="1s">
      					随时随地看牧场，轻松买卖猪牛羊~
      				</div>
              <div style="height:12px;"></div>
              <div class="tit1 wow fadeInUp" data-wow-delay="0.55s" data-wow-duration="1s">
                一款好用的牲畜耳标管理软件
              </div>
              <div style="height:12px;"></div>
              <div class="tit1 wow fadeInUp" data-wow-delay="0.55s" data-wow-duration="1s">
                轻松实现牧场智慧化管理
              </div>
      				<div class="qrcode wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="1s">
      					<img src="../assets/img/images/4.png" />
      					<p>扫码下载&nbsp;小牧丁App<span>目前仅支持 Android 版</span></p>
      					<a class="wapDownload" id="wapDownload" @click="wapDownloads()">点击打开&nbsp;小牧丁App</a>
      					<div class="wapTxt">目前支持 (Android/ios) 版</div>
      					<div style="clear: both;"></div>
      				</div>
      				<div class="txt5 word--magneto wow fadeInUp" data-wow-delay="1s" data-wow-duration="1s">
      					诚邀城市合伙人：17611518222（微信同号）
      				</div>
      			</div>
      			<div class="contImg animated slideInRight delay-5s" data-wow-delay="2s" data-wow-duration="2s">
      				<img src="../assets/img/images/6.png" />
      			</div>
      			<div style="clear: both;"></div>
      		</div>
      		<div style="clear: both;"></div>
      		<div class="powerby word word--magneto wow fadeInUp" data-wow-delay="1s" data-wow-duration="1s">
      			<div class="powerbyTit">
      				<p>生态合作伙伴</p>
      				<p>硬件设备推荐</p>
      			</div>
      			<ul>
      				<li class="yd">
      					<div class="icon"></div>
      					<div class="info">
      						<div class="imgBg"></div>
      						<h6>￥388元<span>（赠送两年7天循环云储存、上门安装）</span></h6>
      						<p>CMCC-IPC-A35</p>
      					</div>
      				</li>
      				<li class="hk">
      					<div class="icon"></div>
      					<div class="info">
      						<div class="imgBg"></div>
      						<h6>￥199元<span>（200像素、30m红外夜视）</span></h6>
      						<p>DS-IPC-B12HV2-IA</p>
      					</div>
      				</li>
      				<li class="ys">
      					<div class="icon"></div>
      					<div class="info">
      						<div class="imgBg"></div>
      						<h6>￥229元<span>（400w像素、日夜全彩）</span></h6>
      						<p>C3C</p>
      					</div>
      				</li>
      				<li class="dh">
      					<div class="icon"></div>
      					<div class="info">
      						<div class="imgBg"></div>
      						<h6>￥188元<span>（200像素、30m红外夜视）</span></h6>
      						<p>DH-IPC-HFW1235M-I1-V2</p>
      					</div>
      				</li>
      				<li class="lc">
      					<div class="icon"></div>
      					<div class="info">
      						<div class="imgBg"></div>
      						<h6>￥299元<span>（200像素、日夜全彩、语音对讲）</span></h6>
      						<p>LC-K32F</p>
      					</div>
      				</li>
      			</ul>
      			<div class="powerbyWeb">陕西微牧云信息科技有限公司<br><a target="_blank" href="http://beian.miit.gov.cn/%22">陕ICP备2020017629号</a></div>
      			<div class="powerbyTit2">陕西微牧云信息科技有限公司<br><a target="_blank" href="http://beian.miit.gov.cn/%22">陕ICP备2020017629号</a></div>
      		</div>
      	</div>
      	<div class="loading" v-show="loadding==true">
      		<div>
      			<img style="width: 40px;height:auto;" src="../assets/img/images/loading3.gif" />
      			<p>加载中...</p>
      		</div>
      	</div>
      </div>
    </el-main>
      <!--发布内容-->
      <div class="dialogs" v-show="dialogs==true" @click="closeDialog"></div>
      <div class="maskss" v-show="editPublick==true">
        <h3>发布内容</h3>
        <div class="close" @click="closeDialog"></div>
        <div class="maskBoxss">
          <div class="uploadImg">
              <p>上传牧场图片<b>*</b></p>
              <div class="avatar-uploader ">
                  <div class="changeFilesBtn" v-if="paramP.imgUrl==''"  style="position: relative;">
                    <input type="file" class="changeFiles" name="" id="" value="文件上传" @change="changeFile"/>
                    <label for=""></label>
                  </div>
                  <div v-else class="imgMuchang">
                    <div class="del" @click="delImg">
                      <img src="../assets/img/closeW.png" >
                    </div>
                     <img  :src="paramP.imgUrl" >
                  </div>
              </div>
          </div>
          <ul>
            <li>
              <label>牧场名称<i>*</i></label>
              <input type="text" v-model="paramP.deviceName" placeholder="请输入牧场名称"/>
            </li>
            <li>
              <label>牧场地址<i>*</i></label>
              <input type="text" v-model="paramP.deviceAddress" placeholder="请输入牧场地址"/>
            </li>
            <li>
              <label>养殖种类<i>*</i></label>
              <div class="typesss">
                 <div v-for="(item,i) in typeP" @click="tabP(item,i)" :class="i==tabIndexP?'cur':''" :key="i">{{item.name}}</div>
              </div>
            </li>
          </ul>
          <div style="clear: both;"></div>
        </div>
        <div class="layuiBtns">
           <a class="cancel" @click="closeDialog">取消</a>
          <a class="confirm" @click="confrim">发布</a>
        </div>
      </div>

    </div>

  </el-container>
</template>
<script>

  import {
    listApi,
    listApiF,
    detailApi,
    uploadFile,
    addCameraDevice

  } from '@/api/index'
  export default {
    name: 'index',
    data() {
      return {
        showclose:false,
        dialogTableVisible: false,
        editPublick:false,
        editInfos:false,
        editDialogs:false,
        editPwds:false,
        address:null,
          collapsed: true,
          imgshow: require('../assets/img/show.png'),
          imgsq: require('../assets/img/sq.png'),
          user: null,
          area:{},
          inputVal:'',
          publishForm:true,
          imageUrl: '',
          typeP: [
            {
              name:'羊',
              type:'1'
            },
            {
              name:'猪',
              type:'2'
            },
            {
              name:'牛',
              type:'3'
            },
            {
              name:'驴',
              type:'4'
            }
          ],
          tabIndexP:-1,
          dialogs:false,
          paramP:{
            imgUrl:'',
            deviceName:'',
            deviceAddress:'',
            livestockType:'',

          },

        phoneshow:false,
        total:0,
        type: ['首页', '羊', '猪', '牛', '驴'],
        typeList: [],
        tjList:[
          {
            deviceName:'牧场名称'
          },
          {
            deviceName:'牧场名称'
          },
          {
            deviceName:'牧场名称'
          },
          {
            deviceName:'牧场名称'
          }
        ],
        lists:[],
        showclass: 'asideshow',
        showtype: false,
        tabIndex: 0,
        param:{
          livestockType: 1,
          current: 1,
          size: 10,
          deviceName:''
        },
        total:0,
        paramsA: {
          current: 1,
          size: 10,
          // livestockType: "",
          // deviceName: ''
        },

        detailFlag:false,
        info:{
          deviceNo:''
        },
        detail:null,
        pageStatus:true,
        showSearch:false,
        loadding:false,
        showPhone:false
      }
    },
    // 注册组件
    components: {
    },
    methods: {
      prePage(){
          if(this.param.current==1){

          }else{
            this.param.current -=1
            this.listAll()
          }
      },
      nextPage(){
        console.log(this.pageStatus)
          if(this.pageStatus){
            this.param.current +=1
            this.listAll()
          }else{
            this.param.page = this.param.current
            this.listAll()

          }
      },
      phone(){
        this.showPhone = true
      },
      testApp(url) {
        window.location = url; //打开某手机上的某个app应用
        this.loadding = true
        setTimeout(function() {
           this.loadding = false
          window.location = "http://down.xiaomuding.com/xiaomuding.apk";
        }, 500);
      },
      downLoad(){
        window.location = "http://down.xiaomuding.com/xiaomuding.apk";
      },
      wapDownloads(w) {
        function detect(){
    let equipmentType = "";
    let agent = navigator.userAgent.toLowerCase();
    let android = agent.indexOf("android");
    let iphone = agent.indexOf("iphone");
    let ipad = agent.indexOf("ipad");
    if(android != -1){
        equipmentType = "android";
    }
    if(iphone != -1 || ipad != -1){
        equipmentType = "ios";
    }
    return equipmentType;
}
  if (detect() == 'android') {
    this.testApp('wmy://detail/memberType')
  } else if (detect() == 'ios') {
    window.location = "https://apps.apple.com/cn/app/id6446979211";
  }

      },

      goback(){
        this.detailFlag = false
      },
      tab(i) {
        this.detailFlag = false
        this.showSearch = false
        this.tabIndex = i
        this.param.current = 1
        this.param.livestockType=i
        this.pageStatus = true
        // this.param.page = 1
        // this.param.deviceName = ''
        this.listAll()
      },
      listAll() {
        listApiF(this.param)
          .then(res => {
            console.log(res)
            if(res.data.data.records.length<10){
              this.pageStatus = false
            }
            this.lists = res.data.data.records
            if(this.param.current==1){
               this.total = res.data.data.total
            }

          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      toDetail(item){
        this.detailFlag = true
        this.info.deviceNo = item.id
        // this.detail()

        // if(item.livestockType==1){
        //   item.livestockType = '羊'
        // }
        // if(item.livestockType==2){
        //   item.livestockType = '猪'
        // }
        // if(item.livestockType==3){
        //   item.livestockType = '牛'
        // }
        // if(item.livestockType==4){
        //   item.livestockType = '驴'
        // }
        // if(item.livestockType==5){
        //   item.livestockType = '鸡'
        // }
        // if(item.livestockType==0){
        //   item.livestockType = '其他'
        // }
        this.showPhone = false


        this.detail = item
         this.detail.userAccounts = this.detail.userAccount.substring(0, 3) + "****" + this.detail.userAccount.substring(7);
      },
      // detail() {

      //   detailApi(this.info)
      //     .then(res => {
      //       this.detail = res.data.data
      //     })
      //     .catch(err => {
      //       this.loading = false
      //       this.$message.error('加载失败，请稍后再试！')
      //     })
      // },
      currentPage(e){
       this.param.current = e
       this.listAll()
      },
      prev(e){
         this.param.current = e
        this.listAll()
      },
      next(e){
        console.log(this.pageStatus)
        if(this.pageStatus==true){
          this.param.current = e
          this.listAll()
        }else{
          this.param.current = parseInt(e-1)
          console.log(this.param.current)
          this.listAll()

        }


      },
      listAlls() {
        listApi(this.paramsA)
          .then(res => {
            this.typeList = res.data.data
          })
          .catch(err => {
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      publish() {
          console.log(this.user)
          if(this.user==null){
           this.$router.push({ path: '/login' })
          }else{
             this.dialogs = true
             this.editPublick = true
          }

        },
        delImg(){
          this.paramP.imgUrl = ''
        },
        changeFile(e) {
          let type = 'test'
          let filea = e.target.files[0];
          let file = new FormData();
          file.append("uploadSign", '0ujQQcy5qcXXMytdV++gUZg0wG9xBijbJOgkiq8o+9C1zptznjhzkH/5TkBdz+TjjaHhHmgdQIvT8EAVk+u/Cg==');
          file.append("file", filea);
          if (process.env.API_HOST == 'http://test.xiaomuding.com/') {
            type = 'test';
          } else {
            type = 'prod';
          }
          uploadFile(file, type)
            .then(res => {
              if (res.data.code == 0) {
                this.paramP.imgUrl = res.data.data.alivideoUrl
              } else {
                _this.$message({
                  type: 'info',
                  message: res.data.msg
                })
              }
            })

        },
        closeDialog(){
          this.dialogs = false
          this.editInfos = false
          this.editPublick = false
          this.editPwds = false
        },
        tabP(item,i) {
          this.paramP.livestockType = item.type
          this.tabIndexP = i
        },
        search(e){
          if(this.inputVal.length>0){
            this.pageStatus = true
            this.tabIndex = 0
            this.param.deviceName = this.inputVal
            this.param.current = 1
            this.param.livestockType = ''
            this.showSearch = true
            this.listAll()
          }

          // this.$emit('#',this.inputVal)
        },
        inputBtn(e){
          this.pageStatus = true
          console.log(this.inputVal)
          this.tabIndex = 0
          this.param.deviceName = this.inputVal
          this.param.current = 1
          this.param.livestockType = ''
          this.showSearch = true
          this.listAll()
        },

      confrim(){
        if(this.paramP.imgUrl==''){
          alert('请上传牧场图片')
        }else if(this.paramP.deviceName==''){
           alert('请输入牧场名称')
        }else if(this.paramP.deviceAddress==''){
           alert('请输入牧场地址')
        }else if(this.paramP.livestockType==''){
           alert('请选择牧场类型')
        }else{
          addCameraDevice(this.paramP).then(res=>{
              this.$message({
                type: 'success',
                message: '发布成功!'
              })
              this.closeDialog()
              this.listAll()
              this.listAlls()
          })
        }
      },

      //个人信息
      editInfo(){
        this.$router.push("info")
        // this.dialogs = true
        // this.editInfos = true
      },
      confrimEditorInfo(){
        this.dialogs = false
        this.editInfos = false
      },

      //修改密码
      editPwd(){
        this.dialogs = true
        this.editPwds = true
      },
      confrimEditorPwd(){
        this.dialogs = false
        this.editPwds = false
      },

        // 退出登录
        exits(){
          this.$store.commit('logout', 'false')
          this.$router.push({ path: '/login' })
          localStorage.removeItem('userInfo')
          this.user = null
        },
        exit() {
          this.$confirm('退出登录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              setTimeout(() => {
                this.$store.commit('logout', 'false')
                this.$router.push({ path: '/login' })
                this.$message({
                  type: 'success',
                  message: '已退出登录!'
                })
                localStorage.removeItem('userInfo')
                this.user = null
              }, 1000)

            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        },
        // 切换显示
        toggle(showtype) {
          this.collapsed = !showtype
          this.$root.Bus.$emit('toggle', this.collapsed)
        }


    },
    async created() {
        // 判断端口
  var browser = {
    versions: function () {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return { //移动终端浏览器版本信息
        WxApp: u.indexOf("MicroMessenger") > 0 //微信打开
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
      this.dialogTableVisible = browser.versions.WxApp;

      this.user = JSON.parse(localStorage.getItem('userInfo'))
      this.param.current = 1
      // 监听
      this.listAlls()
      // this.listJ()
      // this.listQ()
       //判断设备类型
    },
    beforeUpdate() {},
    // 挂载前状态(里面是操作)
    beforeMount() {
      // 弹出登录成功
      // this.$message({
      //   message: '登录成功',
      //   type: 'success'
      // })
    }
  }
</script>
<style >
  .el-dialog__header {
    padding: 10px 20px 10px !important;
}
.el-dialog, .el-pager li {
    background: none;

}
</style>
<style scoped="scoped">
  @import url("index.css");
  @import url("../assets/css/reset.css");
  @import url("../assets/css/animate.css");
  @import url("../assets/css/style.css");
  .footer {
    text-align: center;
    border-top: 1px solid #e8e8e8;
    padding: 20px 0;
  }
  .anniu{
    color: #000;
    font-size: 18px;
    font-weight: 600;
    padding: 8px;
    background-color: #fff;
    width: 30%;
    margin: 0 auto;
    border-radius: 20px;
  }
  .footer p{
    font-size: 16px;line-height: 40px;
  }
  a{
    color:#000;
  }
  .el-main {
    background: #fff!important;
    padding: 0 !important;
  }

  .fl {
    float: left;

  }

  .fr {
    float: right;
  }

  .clear,
  .layui-clear {
    clear: both;
  }

  .over_h {
    overflow: hidden;
  }

  .dis_n {
    display: none;
  }

  .index-nav {
    height: 20px;
    width: 100%;
    background: #F6F7FB;
  }

  .index-con {
    height: calc(100vh - 90px);
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;
  }

  .aside {
    width: 60px !important;
    height: 100%;
    background-color: #fff;
    margin: 0px;
  }

  .asideshow {
    width: 280px !important;
    height: 100%;
    background-color: #f6f7fb;
    margin: 0px;
  }

  .asideshow .el-menu-vertical-demo.el-menu {
    background-color: #f6f7fb !important;
  }

  .el-menu-vertical-demo>li.el-menu-item:nth-child(2) {
    margin-top: 60px
  }

  .index-header {
    padding: 0;
    position:relative;
    height: 90px !important;
    background: #fff;
    box-shadow: 0px 5px 10px rgb(0 0 0 / 3%);
  }

  .index-header .el-menu.el-menu--horizontal {
    background: #fff !important;
    border: none;
    /* box-shadow: 0px 5px 10px rgb(0 0 0 / 3%); */
  }

  .el-submenu {
    min-height: 40px;
    line-height: 40px;
    margin-top:10px
  }

  .el-menu-vertical-demo.el-menu div:last-child {
    border-top: solid 1px #e4e5e7;
  }

  .el-menu-vertical-demo.el-menu div:nth-child(2) i.el-icon-menu::before {
    content: '';
    background: url(../assets/img/u79.png) no-repeat center;
    background-size: 20px auto;
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  .el-menu-vertical-demo.el-menu div:last-child i.el-icon-menu::before {
    content: '';
    background: url(../assets/img/u223.png) no-repeat center;
    background-size: 20px auto;
    width: 20px;
    height: 20px;
    display: inline-block;
  }

  /deep/ .el-menu-item:focus,
  .el-menu-item:hover {
    outline: 0;
    /* background-color: #fff!important; */
  }
  .text{
    display:block;
    width:100px!important;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  /deep/ .el-submenu__title {
    height: 40px;
    line-height: 40px;
    width:150px!important;
    background: #f6f7fb !important;
    border: none;
    color: #333 !important;
    font-size: 16px
  }

  .is-active div span {
    color: #30BF30;
    font-weight: bold;
  }

 /deep/ .el-menu-item {
    /* padding-left: 45px !important; */
    font-size: 15px;
    background: #f6f7fb !important;
    color: #333 !important;
  }

  .el-menu-item.is-active {
    color: #30BF30 !important;
    font-weight: bold;
  }

  .el-menu--horizontal>.el-submenu .el-submenu__title {
    background: #fff !important;
    border: none;
    color: #333 !important;
  }

  .el-menu-demo.el-menu--horizontal.el-menu .submenu.el-submenu {
    border: none
  }

  .el-menu--horizontal {
    /* left: 1163px !important; */
  }

  .el-menu--horizontal .el-menu--popup {
    text-align: center;
  }

  .el-menu.el-menu--popup.el-menu--popup-bottom-start {
    background: #fff !important;
    min-width: 130px !important;
  }

  .el-menu--horizontal .el-menu-item {
    background: #fff !important;
    border: none;
    color: #333 !important
  }

  .index-main {
    padding: 0px;
    background: #fff!important;
  }

  .w1200 {
    width: 1280px;
    margin: 0 auto;
  }
  .w1200:focus{
    outline: 0;
  }
  .cover{
    padding-bottom: 30px;
  }
  .cover > img{
    margin: 50px auto 30px;
    max-width: 100%;
    display: block;
  }
  .goBack{
    font-size: 18px;color:#30BF30;
    text-decoration: underline;
    cursor: pointer;
  }
  .fl.text-{
    font-size: 18px;color:#333;
    width: 98%;
  }
  .detailsBox{
    margin-top: 30px;
  }
  .detailsBoxL{
    width: calc( 100% - 380px);
  }
  .detailsBoxL .imgUrl{
    width: 360px;height:360px;
    background-size: cover;
    float: left;
  }
  .detailsBoxLL{
    float: left;margin-left: 60px;
    width:calc(100% - 420px);
  }
  .detailsBoxLL>.device{
    overflow:hidden;
  }
  .detailsBoxLL>.device span{
    display:inline-block;
    float:left;
  }
  .detailsBoxLL>.device span:nth-child(2){
      width:calc(100% - 74px);
  }
  .detailsBoxLL h3{
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #333333;
    text-align: left;
    line-height: 20px;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .item{
    width: 240px;
    height: 60px;
    background: url(../assets/img/u63.svg) no-repeat center top;
    background-size: cover;
    font-size: 20px;
    color: #FFFFFF;
    outline: none;
    border:none;
    padding: 0;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
  }
  .items{
     width: 240px;
     text-align: center;
     margin-top: 10px;
  }
  .item span{
    line-height: 60px;
  }
  .detailsBoxR{
    float: right;
    width: 340px;
  }
  .detailsBoxR h3{
    font-family: 'Arial Negreta cursiva', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-style: italic;
    font-size: 20px;
    color: #333333;
    text-align: left;
    line-height: 20px;
  }
  .detailsBoxR h3 span{
    width: 40px;
    height: 20px;
    background-color: rgba(245, 247, 250, 1);
    border-radius: 2px;
    font-size: 12px;
    color: #999999;
    line-height: 20px;
    display: inline-block;
    float: right;
    font-style: normal;
    text-align: center;
    font-weight: normal;
  }
  .detailsBoxR ul{}
  .detailsBoxR ul li{
    float: left;
    width: 160px;
    margin:20px 20px 0 0;
  }
  .detailsBoxR ul li:nth-child(2n){
     margin:20px 0px 0 0;
  }
  .detailsBoxR ul li div,
  .detailsBoxR ul li img{
    width: 160px;
    height: 160px;
    cursor: pointer;
    background-size: cover;
  }
  .detailsBoxR ul li p{
    margin-top: 10px;font-size: 16px;
    color: #666666;overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .yzm-search{
  	display: inline-block;
    margin:10px 0 0 60px
  }
  .searchtxt{
  	float:left;width: 366px;
  	height: 36px;border:2px solid #30bf30;
  	border-right:0;position:relative;
  	z-index:100;background:#fff;
  	border-radius: 5px;
  }
  .searchtxt input{
  	float:left;border:0;
  	background:#fff;color:#666;
  	padding:7px 8px;width: 96%;
  	height:22px;line-height:22px;
  	margin:0;outline:medium none;
  	text-indent: 5px;
  }
  .searchbtn{
  	float:left;
  }
  .searchbtn div{
  	background: #30bf30;
    color: #fff;
    outline: none;
    cursor: pointer;
    float: left;
    height: 40px;
    line-height: 40px;
    width: 80px;
    font-size: 16px;
    transition: all 0.3s;
    border-radius: 5px;
    margin-left: -7px;
    text-indent: 7px;
    text-align: center;
  }
  .yzm-add-content{
  	width: 99px;float:right;
  	margin-left: 30px;
  }
  .yzm-add-content a{
    text-decoration: none;
  	border-radius:2px;height: 38px;
  	color:#30bf30;font-size:14px;
  	display:block;line-height: 40px;
  	transition:0.3s all;
  	border:1px solid #30bf30;
  	text-align:center;border-radius: 5px;
  }
  .yzm-add-content a:hover{
  	text-decoration:none;
  	background:#30bf30;color:#fff;
  }
  .w1200{
    width: 1280px;
    margin:0 auto;
  }
  .el-menu-demo{
    position:fixed;
    top:15px;
    left:0;
    width:100%;
    z-index:999;
  }
  .titleT{
    color: #333333;
    font-size: 24px;
    /* margin-left: 15px; */
    font-weight:bold;
    display: inline-block;
    vertical-align: middle;
    height:60px;
    line-height:60px;
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  }
  .areaTitle{
    margin-left: 10px;
    margin-top: 15px;
    height: 30px;
    background-color: rgba(235, 235, 235, 1);
    border-radius: 15px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 14px;
    color: #666666;
    line-height: 30px;
    padding: 0 10px;
  }
  .areaTitle img{
    width: 14px;
    height: 14px;
    opacity: .6;
    vertical-align:middle;

  }
  .titleImg{
    width: 30px;
    height:30px;
    border-radius:50%;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
  }
  .submenu {
    float: right;
  }
  .buttonimg {
    height: 60px;
    background-color: transparent;
    border: none;
  }
  .showimg {
    width: 26px;
    height: 26px;
    position: absolute;
    top: 17px;
    left: 17px;
  }
  .showimg:active {
    border: none;
  }
  .logobox img {
    width: 120px;
    height: 40px;
    margin: 10px 20px 0 0;
  }
  .dialogs{
    position: fixed;left:0;right:0;top:0;
    bottom:0;margin: auto;
    background: rgba(0,0,0,.25);
    z-index: 9999999;
    outline: none;
  }
  .maskss{
    position: fixed;left:0;right:0;top:0;
    bottom:0;margin: auto;
    width: 640px;
    height: 500px;
    z-index: 9999999;
    padding: 20px 40px;
    outline: none;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;
    -moz-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0470588235294118);
    -webkit-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0470588235294118);
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.0470588235294118);
  }
  .maskss h3{
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    line-height: 20px;
  }
  .close{
    position: absolute;
    width: 20px;
    height: 20px;
    background: url(../assets/img/images/close.png) no-repeat center;
    background-size: 20px 20px;
    right:20px;top:20px;cursor: pointer;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      width: 240px;height:240px;;
      font-size: 70px;
      color: #8c939d;
      line-height: 240px;
      text-align: center;
    }
    .avatar {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .maskBoxss{
      margin-top: 60px;
    }
    .uploadImg{
      width: 240px;
      float: left;
    }
    .uploadImg p,
    .maskBoxss ul li label{
      font-size: 16px;color:#333;
      margin-bottom: 10px;
      display: block;
    }
    .uploadImg p b,
    .maskBoxss ul li label i{
      font-weight: normal;
      color:#D92121;margin-left: 5px;
      font-style: normal;
    }
    .avatar-uploader{
     width: 240px;
     height: 240px;
     position: relative;
     background-color: rgba(255, 255, 255, 1);
     box-sizing: border-box;
     border-width: 1px;
     border-style: solid;
     border-color: rgba(217, 217, 217, 1);
     border-radius: 5px;
    }
    .avatar-uploader .imgMuchang{
       width: auto;
       height: auto;
       max-width: 100%;
       max-height: 100%;
       display: block;
       position: absolute;
       left: 0;
       right: 0;
       top: 0;
       bottom: 0;
       margin: auto;
    }
     .avatar-uploader .imgMuchang img{
       max-width:100%;
       position: absolute;
       left: 0;
       right:0;
       top: 0;
       margin: auto;
       bottom: 0;
     }
    .imgMuchang .del{
      position:absolute;
      right:0;
      top:0;
      width: 40px;
      height:40px;
      z-index: 99999;
      cursor: pointer;
      background:rgba(0,0,0,.5);

    }
    .imgMuchang .del>img{
       margin:7px;
      width:26px;
      height:26px;
    }
    .maskBoxss ul{
      float: right;width: 360px;
    }
    .maskBoxss ul li{
      margin-bottom: 30px;
      position: relative;
    }
    .maskBoxss ul li input{
      width: 360px;
      height: 40px;
      background-color: rgba(255, 255, 255, 1);
      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(217, 217, 217, 1);
      border-radius: 5px;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      box-shadow: none;
      font-size: 16px;
      text-align: left;
      text-indent: 16px;
      line-height: 40px;
    }
    .typesss{}
    .typesss > div{
      width: 58px;
      height: 38px;
      background-color: rgba(245, 245, 245, 1);
      border: solid 1px rgba(245, 245, 245, 1);
      border-radius: 5px;
      font-size: 16px;
      color: #666666;
      line-height: 40px;
      display: inline-block;
      margin-right: 20px;
      text-align: center;
      cursor: pointer;
    }
    .typesss > div.cur{
      border-color: rgba(48, 191, 48, 1);
      color: #30BF30;
    }
    .layuiBtns{
      text-align: center;
      margin-top: 50px;
    }
    .layuiBtns a{
      text-align: center;
      width: 100px;
      height: 40px;
      line-height: 40px;
      display: inline-block;
      border-radius: 5px;
      margin: 0 10px;
      font-size: 16px;
      color: #333;
      cursor: pointer;
    }
    .layuiBtns a.confirm {
      background: #30BF30;
      color: #fff;
    }
    .layuiBtns a.cancel {
      border: 1px solid #dedede;
      height: 38px;
      line-height: 38px;
      width: 98px;
      background: #fff;
    }
    .changeFilesBtn{
      background: url(../assets/img/upload2.png) no-repeat center;
     background-size: 130px auto;
     border: none;
     width: 240px;
     height: 240px;
     margin: 0 !important;
     padding: 0;
     border:none !important;
    }
    .changeFiles{
      cursor: pointer;
      position: absolute;
      width: 240px;height:240px;left: 0;top:0;opacity: 0;
    }
    /deep/ .el-button--primary:focus, .el-button--primary:hover{
      background:transparent!important;
    }
    /deep/ .el-button--primary.is-active, .el-button--primary:active{
      background:transparent!important;
    }
    .getCode{
      position: absolute;
      right: 5px;
      top: 30px;
      display: inline-block;
      height: 40px;
      line-height: 40px;
      border: none;
      outline: none;
      cursor: pointer;
      width: 120px;
      float: right;
      border-radius: 5px;
      text-align: center;
      font-size: 16px;
    }
    .bottomPage{
      width: 300px;
      margin:20px auto;
      overflow:hidden;
    }
    .bottomPage>div:nth-child(1){
      margin-right:10px;
    }
    .bottomPage>div{
      width:100px;
      float:left;
      border:1px solid #e7e7e7;
      text-align:center;
      padding:10px 0;
    }
    .el-container.main-con{
      background:#fff!important;
    }
    @media (max-width:959px) {
      .mobile{
        height: 100vh;
        background: -webkit-linear-gradient(0deg, rgba(38, 153, 38, 1) 0%, rgba(119, 183, 55, 1) 100%) !important;
        background: -webkit-linear-gradient(0deg, rgba(38, 153, 38, 1) 0%, rgba(119, 183, 55, 1) 100%) !important;
        background: -webkit-linear-gradient(0deg, rgba(38, 153, 38, 1) 0%, rgba(119, 183, 55, 1) 100%) !important;
        transition: All 0.15s ease-in-out;
        -webkit-transition: All 0.15s ease-in-out;
        -moz-transition: All 0.15s ease-in-out;
        -o-transition: All 0.15s ease-in-out;
      }
    }
    .loginBtn{
      position:absolute;
      right:0;
      top:10px;
      z-index:999999;
      padding:10px;
      background:#f6f7f7;
      cursor: pointer;
    }
    .pos-rel{
      position:relative;
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue